import { InfoCircleFilled } from "@ant-design/icons";
import { Col, Radio, Row, Tooltip } from "antd";
import { useField } from "formik";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import scannerImg from "assets/images/check-in/checkin-scanner.png";
import appImg from "assets/images/check-in/checkin-app.png";
import bothImg from "assets/images/check-in/checkin-both.png";

// map ตาม MstCommonType.code (groupTypeCode = CHECKIN_CHANEL)
const ICONS = {
    CHECKIN_CHANEL_01: scannerImg,
    CHECKIN_CHANEL_02: appImg,
    CHECKIN_CHANEL_03: bothImg,
};

const STYLES = `
.checkin-card { transition: border-color .15s ease, box-shadow .15s ease; }
.checkin-card:not([aria-disabled="true"]):hover { border-color: #91c0f8; }
.checkin-card:focus-visible { outline: 2px solid #2f80ed; outline-offset: 2px; }
`;

const CheckInChanelCards = ({
    name = "checkInChanelId",
    options = [],
    disabled = false,
}) => {
    const { t } = useTranslation();
    const [field, meta, helpers] = useField(name);

    const sortedOptions = useMemo(
        () =>
            [...options].sort((a, b) => (a.code || "").localeCompare(b.code || "")),
        [options]
    );

    const select = (value) => {
        if (disabled) return;
        helpers.setValue(value);
        helpers.setTouched(true, false);
    };

    const onKeyDown = (e, value) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            select(value);
        }
    };

    return (
        <div style={{ background: "#F3F8FF", borderRadius: 16, padding: 24 }}>
            <style>{STYLES}</style>

            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <b style={{ fontSize: 18 }}>{t("othersetting.check-in-source")}</b>
                <Tooltip title={t("othersetting.check-in-source-tip")}>
                    <InfoCircleFilled style={{ color: "#2F80ED", fontSize: 18 }} />
                </Tooltip>
                <span style={{ color: "#ff4d4f" }}>*</span>
            </div>
            <p style={{ margin: "4px 0 16px", color: "#555" }}>
                {t("othersetting.check-in-source-desc")}
            </p>

            <Row gutter={[16, 16]} role="radiogroup">
                {sortedOptions.map((opt) => {
                    const selected = field.value === opt.value;
                    const iconSrc = ICONS[opt.code];

                    return (
                        <Col key={opt.value} xs={24} md={8}>
                            <div
                                className="checkin-card"
                                role="radio"
                                aria-checked={selected}
                                aria-disabled={disabled}
                                tabIndex={disabled ? -1 : 0}
                                onClick={() => select(opt.value)}
                                onKeyDown={(e) => onKeyDown(e, opt.value)}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 16,
                                    height: "100%",
                                    padding: 20,
                                    background: "#fff",
                                    borderRadius: 12,
                                    border: `1.5px solid ${selected ? "#2F80ED" : "#E5E7EB"}`,
                                    boxShadow: selected
                                        ? "0 0 0 3px rgba(47,128,237,.12)"
                                        : "none",
                                    cursor: disabled ? "not-allowed" : "pointer",
                                    opacity: disabled && !selected ? 0.6 : 1,
                                }}
                            >
                                <Radio
                                    checked={selected}
                                    disabled={disabled}
                                    tabIndex={-1}
                                    style={{ pointerEvents: "none" }}
                                />

                                {iconSrc && (
                                    <div
                                        style={{
                                            flex: "0 0 auto",
                                            width: 96,
                                            height: 72,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <img
                                            src={iconSrc}
                                            alt={opt.label}
                                            loading="lazy"
                                            draggable={false}
                                            style={{
                                                maxWidth: "100%",
                                                maxHeight: "100%",
                                                objectFit: "contain",
                                            }}
                                        />
                                    </div>
                                )}

                                <div>
                                    <b style={{ fontSize: 16 }}>{opt.label}</b>
                                    <div style={{ color: "#555", marginTop: 4 }}>
                                        {t(`othersetting.check-in-desc-${opt.code}`, {
                                            defaultValue: "",
                                        })}
                                    </div>
                                </div>
                            </div>
                        </Col>
                    );
                })}
            </Row>

            {meta.touched && meta.error ? (
                <div style={{ color: "#ff4d4f", marginTop: 8 }}>{meta.error}</div>
            ) : null}
        </div>
    );
};

export default CheckInChanelCards;